import icLayers from '@iconify/icons-ic/twotone-layers';
import icChat from '@iconify/icons-ic/twotone-chat';
import icAccountCircle from '@iconify/icons-ic/twotone-account-circle';
import icDescription from '@iconify/icons-ic/twotone-description';
import { NavigationItem } from 'src/@vex/interfaces/navigation-item.interface';
import {
  clientRead, messageRead, kycRead, paymentRead,
  auditLogRead, localizationRead, configRead,
  staffRead, roleRead
} from 'src/app/app.constants';

export const navigationItems: NavigationItem[] = [
  {
    type: 'link',
    label: 'dashboard',
    route: '/',
    icon: icLayers
  },
  {
    type: 'link',
    label: 'clients',
    route: '/clients',
    icon: icLayers,
    requiredPrivilege: clientRead
  },
  {
    type: 'subheading',
    label: 'inbox',
    children: [
      {
        type: 'link',
        label: 'supportChat',
        icon: icChat,
        route: '/messages/support',
        requiredPrivilege: messageRead
      },
      {
        type: 'link',
        label: 'announcement',
        icon: icChat,
        route: '/messages/announcement',
        requiredPrivilege: messageRead
      },
      {
        type: 'link',
        label: 'polls',
        icon: icChat,
        route: '/messages/polls',
        requiredPrivilege: messageRead
      }
    ]
  },
  {
    type: 'link',
    label: 'kycRequests',
    route: '/kyc-requests',
    icon: icLayers,
    requiredPrivilege: kycRead
  },
  {
    type: 'subheading',
    label: 'reporting',
    children: [
      {
        type: 'link',
        label: 'cumulativeReports',
        icon: icDescription,
        route: '/cumulative-reports',
        requiredPrivilege: configRead
      }
    ]
  },
  {
    type: 'subheading',
    label: 'transactions',
    children: [
      {
        type: 'link',
        label: 'bankTransfer',
        icon: icAccountCircle,
        route: '/bank-transfer',
        requiredPrivilege: paymentRead
      }
      //      {
      //        type: 'link',
      //        label: 'ccpTransaction',
      //        icon: icAccountCircle,
      //        route: '/crypto-coin-pro-transaction'
      //      }
    ]
  },
  {
    type: 'subheading',
    label: 'loans',
    children: [
      {
        type: 'link',
        label: 'loanRequests',
        icon: icDescription,
        route: '/collateralized-loans',
        requiredPrivilege: paymentRead
      },
      {
        type: 'link',
        label: 'activeServices',
        icon: icDescription,
        route: '/active-services',
        requiredPrivilege: paymentRead
      }
    ]
  },
  {
    type: 'link',
    label: 'auditLogs',
    route: '/audit-logs',
    icon: icLayers,
    requiredPrivilege: auditLogRead
  },
  {
    type: 'link',
    label: 'localization',
    route: '/localization',
    icon: icLayers,
    requiredPrivilege: localizationRead
  },
  {
    type: 'link',
    label: 'properties',
    route: '/properties',
    icon: icLayers,
    requiredPrivilege: configRead
  },
  {
    type: 'subheading',
    label: 'userManagement',
    children: [
      {
        type: 'link',
        label: 'users',
        icon: icAccountCircle,
        route: '/users',
        requiredPrivilege: staffRead
      },
      {
        type: 'link',
        label: 'roles',
        icon: icAccountCircle,
        route: '/roles',
        requiredPrivilege: roleRead
      }
    ]
  }
];
